<template>
    <div v-cloak class="login" v-if="isApi && !showDemo">
        <div class="title"><img v-if="customTemplate  && showLogo" :src="customTemplate.logo_home" :style="customTemplate.logo_login_style_wob"/></div>
        <br>
        <div id="mem" class="mem">
            <div id="err_info" class="err_info">
                        <font id="hr_info">{{ lang.sessionExipred }}</font>
             </div>
        </div>
    </div>
    <div v-cloak class="login" v-else>
        <popupFestival></popupFestival>
        <popup v-if="popupFlag" :democreditLogin="popupFlag" :lang="lang" ></popup>
      
        <div class="title">
            <ul class="language">
                <span>
                    <li :class="langClass(langSelect[2].language_code)" @click="changeLanguage(2)">
                        <p>{{langSelect[2].caption}}版</p>
                    </li>
                </span>
                <span>
                    <li :class="langClass(langSelect[3].language_code)" @click="changeLanguage(3)">
                        <p>{{langSelect[3].caption}}版</p>
                    </li>
                </span>
                <span>
                    <li :class="langClass(langSelect[1].language_code)" @click="changeLanguage(1)">
                        <p>{{langSelect[1].caption}}</p>
                    </li>
                </span>
                <span>
                    <li :class="langClass(langSelect[5].language_code)" @click="changeLanguage(5)">
                        <p>{{langSelect[5].caption}}</p>
                    </li>
                </span>
                <span>
                    <li :class="langClass(langSelect[6].language_code)" @click="changeLanguage(6)">
                        <p>{{langSelect[6].caption}}</p>
                    </li>
                </span>
                <span>
                    <li :class="langClass(langSelect[7].language_code)" @click="changeLanguage(7)">
                        <p>{{langSelect[7].caption}}</p>
                    </li>
                </span>
                <span>
                    <li :class="langClass(langSelect[8].language_code)" @click="changeLanguage(8)">
                        <p>{{langSelect[8].caption}}</p>
                    </li>
                </span>
                <span>
                    <li :class="langClass(langSelect[9].language_code)" @click="changeLanguage(9)">
                        <p>{{langSelect[9].caption}}</p>
                    </li>
                </span>
                <span>
                    <li :class="langClass(langSelect[10].language_code)" @click="changeLanguage(10)">
                        <p>{{langSelect[10].caption}}</p>
                    </li>
                </span>
                <span>
                    <li :class="langClass(langSelect[4].language_code)" @click="changeLanguage(4)">
                        <p>{{langSelect[4].caption}}</p>
                    </li>
                </span>
                <span>
                    <li :class="langClass(langSelect[11].language_code)" @click="changeLanguage(11)">
                        <p>{{langSelect[11].caption}}</p>
                    </li>
                </span>
            </ul>
        </div>
        <div id="mem" class="mem">
            <div :class="customIcon()" class="logo-placement" ><img v-if="customTemplate" :src="customTemplate.login_logo"/><!--icon--></div>
            <div class="log">
                <form id="LoginForm" name="LoginForm">
                    <div class="bordDIV">
                        <table border="0" cellpadding="0" cellspacing="0" class="bord">
                            <tr>
                                <td width="6">&nbsp;</td>
                                <td class="index_ID index_line">
                                    <img src="assets/images/index_ID.jpg">
                                </td>

                                <td class="index_line place_colorTD">
                                    <input type="text" v-model="formData.accname" id="username" size="15" class="place_colorBOX" :maxlength="inputLength.username" tabindex="1">
                                    <input type="text" id="username_def" size="10" class="place_color placeholder" :maxlength="inputLength.username"  v-model="lang.username_def" :style="altDisplay()">
                                </td>
                                 <td width="6">&nbsp;</td>
                            </tr>
                            <tr>
                                <td width="6">&nbsp;</td>
                                <td class="index_ID"><img src="assets/images/index_pass.jpg"></td>
                                <td class="place_colorTD">
                                    <input type="password" v-model="formData.pass" id="passwd" size="15"  class="place_colorBOX" :maxlength="inputLength.password" tabindex="2">
                                    <input type="text" v-model="lang.password_def" :style="{'visibility' : formData.pass.length <= 0 ? 'visible' : 'hidden'}" id="password_def" size="10" class="place_color placeholder" :maxlength="inputLength.username" >
                                <td width="6">&nbsp;</td>
                            </tr>
                        </table>
                    </div>
                    <div id="err_info" class="err_info" v-show="error.loginIdReq">
                        <font id="hr_info">{{ error.message }}</font>
                    </div>
                    <div class="index_re">
                        <span class="err_position"><!--input type="checkbox" id="remember" class="index_box">Remember Me-->
                            <label>
                                <input type="checkbox" id="remember" class="index_box"><span></span>{{ lang.rememberMe }}
                            </label>
                        </span>
                    </div>
                    <button type="submit" class="btn btn-block za_button" @click.prevent="login" tabindex="3">{{ lang.login }}</button>
                    <button v-if="showDemo" type="submit" class="btn btn-block za_button" @click.prevent="demoLogin" tabindex="3">{{ lang.demo }}</button>
                    <button v-if="showCreditDemoFlag" type="submit" class="btn btn-block za_button" @click.prevent="demo" tabindex="3">{{ lang.demo }}</button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import popupFestival from '../../components/popup-festival'
import popup from '../../components/popup.vue'
import vueCookie from 'vue-cookie'
import authCommon from '../../mixins/authCommon'
// import popupCommon from '../../mixins/popup'
import EventBus from '@/vue/events/event-bus'


export default {
    mixins: [authCommon],
    components: {
      popupFestival,
      popup,
    },
    data() {
        return {
            langSelect : lang_select,
            cookielang: _cookie,
            lang: lang,
            formData : {
                accname : '',
                pass: '',
            },
            error: {
                loginIdReq: false,
                message: '',
            },
            customTemplate : window._customTemplate,
            popupFlag: false,
            emptytoken :window.emptytoken,
            showCreditDemoFlag:window.showCreditDemoFlag,
            token :window.token,
            showDemo: window.showDemo,
            showLogo: window.showLogo,
            isApi: window.isApi,
        }
    },
    methods : {
        altDisplay(){
            if(!this.formData.accname){
                return 'visibility : visible'
            }
            var style = this.formData.accname.length <= 0 ? 'visible' : 'hidden'
            return 'visibility : '+ style
        },
        customIcon(){
            if(this.customTemplate && !this.customTemplate['login_logo']){
                return 'index_top_pic'
            }
        },
        login () {
            if(this.formData.accname == '') {
                this.error.loginIdReq = true
                this.error.message = this.lang.emptyLoginId
            } else if(this.formData.pass == '') {
                this.error.loginIdReq = true
                this.error.message = this.lang.emptyPassword
            } else {
                this.error.loginIdReq = false
                this.formData.token = token.arr_9+'|'+this.formData.accname
                this.$ajax({
                    method: 'post',
                    url: '',
                    data: this.formData,
                }).done(response => {
                    if($('#remember:checked').length > 0){
                        vueCookie.set('_userName', this.formData.accname )
                    }else{
                        vueCookie.set('_userName', null)
                    }
                }).catch(error => {
                  this.error.loginIdReq = true
                  this.error.message = error.responseJSON.message
                })
            }
        },
        changeLanguage : function(value){
            this.$ajax({
              url: '',
              type: 'get',
              data: {
                language: value,
                token: token.arr_3,
              },
            }).then(response => {
                window.location.reload();
            })
        },
        lang_allowed(langid){
            if(langid == 1 || langid == 2 || langid == 3 ){
                return true;
            }
            return false;
        },
        langClass(lang) {
            if(lang == this.cookielang){
                return 'lang2';
            }
            return 'lang';
        },
        demo(){
            this.popupFlag = true;
        },
        demoLogin(){
            this.$ajax({
                method: 'post',
                url: window.demoLogin,
                data: {
                    token: token.arr_9
                }
            }).done(((res)=> {
                //window.location.href = res.redirect
                return false
            
            }).bind(this)).catch((errRes)=> {
                console.log(errRes)
            })
        },
    },
    mounted(){
        $('#loading-root-ele').hide()
        if(vueCookie.get('_userName') != 'null'){
            this.formData.accname = vueCookie.get('_userName')
            $('#remember').prop('checked', true);
        }else{
            $('#remember').prop('checked', false);            
        }
        $('#username').focus();

        EventBus.$on('setDemoFlag', (res)=> {
            this.popupFlag = res;
        })

        
    }
}
</script>
<style lang="scss">
@import "~@/styles/base/global";
@import "~@/styles/auth/login";
</style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/auth/login.vue